// extracted by mini-css-extract-plugin
export default {"btn":"styles_btn__asngd","saveBtn":"styles_saveBtn__79O71","cancelBtn":"styles_cancelBtn__vDYwS"};